import React from "react";
import { CheckCircle2, ShieldCheck, AlertTriangle } from "lucide-react";

export const SafetyTab = ({jobCard}: {jobCard: any}) => {
  const safetyEquipment = jobCard?.sop?.safetyRequirements?.safetyEquipment || [];
  const safetyProtocol = jobCard?.sop?.safetyRequirements?.safetyProtocol || [];

  return (
    <div className="p-6 bg-white min-h-screen">
      {/* Safety Equipment */}
      <div className="mb-8">
        <h3 className="flex items-center gap-2 font-semibold text-gray-800 mb-4 text-[15px]">
          <CheckCircle2 className="w-4 h-4 text-blue-500" /> Safety Equipment
        </h3>
        {safetyEquipment.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            {safetyEquipment.map((equipment: any) => (
              <div key={equipment.id} className="bg-white border text-sm border-gray-100 rounded-lg p-5 shadow-sm flex flex-col items-center justify-center text-center gap-3">
                <ShieldCheck className="w-5 h-5 text-blue-500" />
                <p className="font-medium text-gray-800 text-sm">{equipment.name}</p>
                {equipment.description && (
                  <p className="text-gray-500 text-[12px]">{equipment.description}</p>
                )}
              </div>
            ))}
          </div>
        ) : (
          <p className="text-sm text-gray-500">No safety equipment specified.</p>
        )}
      </div>

      {/* Safety Protocols */}
      <div className="mb-8">
        <h3 className="flex items-center gap-2 font-semibold text-gray-800 mb-4 text-[15px]">
          <AlertTriangle className="w-4 h-4 text-orange-500" /> Safety Protocols
        </h3>
        {safetyProtocol.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {safetyProtocol.map((protocol: any) => (
              <div key={protocol.id} className="bg-white border text-sm border-orange-100 rounded-lg p-5 shadow-sm flex items-start gap-4">
                <AlertTriangle className="w-5 h-5 text-orange-400 shrink-0 mt-0.5" />
                <div>
                  <p className="font-semibold text-gray-800 mb-1">{protocol.name}</p>
                  <p className="text-gray-500 text-[13px]">{protocol.description}</p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-sm text-gray-500">No safety protocols specified.</p>
        )}
      </div>
    </div>
  );
};
